import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Optional
} from '@angular/core';
import { DropdownComponent } from './dropdown.component';
import { DropdownMenuComponent } from './dropdown-menu.component';

@Component({
  selector: 'mtg-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownItemComponent implements OnInit {
  @Input()
  value: any;
  dropdownValue: any;
  @HostBinding('class.dropdown-item')
  defaultClass = true;
  @HostBinding('class.hidden')
  hidden: boolean;

  constructor(
    @Optional() private dropdownComponent: DropdownComponent,
    @Optional() private dropdownMenuComponent: DropdownMenuComponent,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (this.dropdownComponent) {
      this.dropdownComponent.value$.subscribe(value => {
        this.dropdownValue = value;
        this.cdr.markForCheck();
      });
      this.dropdownComponent.search$.subscribe((search: string) => {
        this.hidden = search && this.viewValue.toLowerCase().indexOf(search.toLowerCase()) < 0;
        this.cdr.markForCheck();
      });
      this.dropdownComponent.updateView();
    }
  }

  @HostListener('click')
  onClick() {
    if (this.dropdownComponent) {
      this.dropdownComponent.onItemClick(this);
    } else if (this.dropdownMenuComponent) {
      this.dropdownMenuComponent.hide();
    }
  }

  get viewValue(): string {
    return (this.elementRef.nativeElement.textContent || '').trim();
  }

  @HostBinding('class.active')
  get activeClass() {
    return this.active;
  }

  get active() {
    if (!this.dropdownComponent) {
      return false;
    }
    if (this.dropdownComponent.multi) {
      return this.dropdownComponent.value.indexOf(this.value) > -1;
    } else {
      return this.dropdownComponent.value === this.value;
    }
  }
}
